$(document).ready(function () {
  // Scroll to Top button
  $(".scroll-to-top").click(function (e) {
      e.preventDefault(); // Prevents the default button behavior
      $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  // Variant Changed Event
  document.addEventListener('variants:change', (event) => {
    const variant = event.detail.variant; // Extract the variant data from the event
    // console.log('Variant changed:', variant);
  });


  // Listen for changes on *any* radio input that switches units
  document.querySelectorAll('[custom-tab-content] [data-tab]').forEach(input => {
    input.addEventListener('change', (event) => {
      const selectedInput = event.target;
      const selectedUnit = selectedInput.value;

      // Find the nearest container for this specific size chart
      const sizeTabContainer = selectedInput.closest('[custom-tab-content]');
      if (!sizeTabContainer) return;

      // Hide all tables inside this popup
      const tables = sizeTabContainer.querySelectorAll('[data-content]');
      tables.forEach(table => {
        if (table.dataset.content === selectedUnit) {
          table.classList.remove('hidden');
        } else {
          table.classList.add('hidden');
        }
      });
    });
  });

  // Custom Trigger to open the Reamaze App Chat
  document.querySelectorAll('.help-chat-box [href="#"]').forEach(ele => {
    ele.addEventListener('click', (event) => {
      event.preventDefault();
      if(Reamaze){
        Reamaze.popup();
      }
    });
  });

});

// Swiper Slide Center Align Start
function slideCenterAlign(swiper) {
  const container = swiper.el;
  if (!container) return;

  const totalSlides = swiper.slides.length;
  let currentSlidesPerView = swiper.params.slidesPerView;

  if(!totalSlides && !currentSlidesPerView) return;

  const isScrollable = totalSlides < currentSlidesPerView;
  container.classList.toggle('slide-not-scrollable', isScrollable);
}
// Swiper Slide Center Align End


// Free Product Bar Start
$(document).ready(function(){
  $('.free-product-bar .free_pro_close').click(function(){
    closeFreeProBar();
  });
});

function closeFreeProBar() {
  let stickyHeader = document.querySelector('sticky-header');
  let freeProBar = document.querySelector('.free-product-bar');
  if (stickyHeader && freeProBar) {
    document.documentElement.style.setProperty('--header-height', stickyHeader.offsetHeight - freeProBar.offsetHeight + 'px');
    freeProBar.classList.add('hidden');
  }
}
// Free Product Bar End


// Free Product Popup Start
$(document).ready(function(){
  $('.free_product_popup_container .free_product_modal_close').click(function(){
    closefreeProPopup();
  });
});

function activeFreeProBar() {
  $('.free-product-bar').show();
}
function closefreeProPopup() {
  document.querySelector('.free_product_popup_container').classList.remove('open');
}

// Product Added and check the Free Product Available in the Cart
document.addEventListener('product:added', function(event) {
  openfreeProPopup(event);
});

// Cart Update and check the Free Product Available in the Cart
document.addEventListener('cart:updated', function(event) {
  let cartJSON = event.detail;
  let source = event.detail.source;

  if(source == 'add-to-cart'){
    getCartJSON().then(cart => {
      freeproRemove(cart);
    });
  } else if(source == 'cart-change') {
    freeproRemove(cartJSON.data);
  }
});

// function freeproRemove(cartJSON){
//   console.log('cartJSON',cartJSON);
  
//   const itemsWithFreeProHandles = cartJSON.items.filter((item) => item?.properties?._free_pro_handles);
//   // console.log('itemsWithFreeProHandles',itemsWithFreeProHandles);

//   if (itemsWithFreeProHandles.length > 0) {
//     let freeArryDetails = [];

//     // Loop through each cart item and check for matches using find
//     itemsWithFreeProHandles.forEach((freepro) => {
//       const freeProHandles = freepro?.properties?._free_pro_handles.split(',');
//       const matchingHandle = cartJSON.items.find((item) => { return freeProHandles.includes(item.handle);});
//       freeArryDetails.push({status: matchingHandle , free_pro:freepro});
//     });
//     // console.log('freeArryDetails',freeArryDetails);
    
//     const freeProRemoveList = freeArryDetails.map((update) => {
//     if (!update.status) {
//       // If status is undefined, create a new object with id and quantity 0
//       return {
//         id: update.free_pro.key, // Ensure 'key' exists on 'free_pro'
//         quantity: 0,
//       };
//     }
//     // If status is defined, return null to filter it out later
//     return null;
//   })
//   .filter((item) => item !== null);
//     // console.log('freeProRemoveList',freeProRemoveList);
    
//     if (freeProRemoveList.length > 0) {
//       fetch("".concat(window.routes.cart_update_url, "/update.js"), {
//         body: JSON.stringify({
//           updates: freeProRemoveList.reduce((acc, curr) => {
//             acc[curr.id] = curr.quantity;
//             return acc;
//           }, {})
//         }),
//         credentials: 'same-origin',
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest', // This is needed due to a known bug in Shopify
//         }
//       })
//       .then((response) => response.json())
//       .then((content) => {
//         console.log('content',content);
        
//         // Optionally update cart drawer contents
//         if (cartDrawer && content.sections) {
//           cartDrawer.renderContents(data);
//         }
//         // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         //   bubbles: true  //this code is for prestige theme, is to refresh the cart
//         // }));
//       })
//       .catch((error) => {
//         console.error('Error updating cart:', error);
//       });
//     }
    
//   } else {
//     console.log('No items with _free_pro_handles found');
//   }


//   // Cart item coundown timer Start
//   const timer = cartJSON.items.filter((item) => item?.properties?._free_pro_mm);
//   // console.log('timer',timer);
//   if (timer.length > 0) {
//     timer.forEach((item) => {
//       let mm = item?.properties?._free_pro_mm;
//       let ss = item?.properties?._free_pro_ss;
//       let timerStatus = item?.properties?._free_pro_timer;
//       // console.log(timerStatus);
//       // Start a countdown for a specific id with 15 minutes and 0 seconds
//       if(timerStatus){
//         startCountdown(item.id, mm, ss);
//       }
      
//     });
//   }
//   // Cart item coundown timer End
// }

function freeproRemove(cartJSON) {
  // console.log('cartJSON', cartJSON);
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const freeItems = cartJSON.items.filter(item => item?.properties?._free_pro_handles);
  const removeUpdates = [];
  const removeItems = [];

  freeItems.forEach(freeItem => {
    const handles = freeItem.properties._free_pro_handles.split(',');
    const match = cartJSON.items.find(item => handles.includes(item.handle));
    if (!match) {
      removeUpdates.push({ id: freeItem.key, quantity: 0 });
      removeItems.push({ id: freeItem.id, quantity: 0 });
    }
  });

  if(removeItems.length > 0) {
    // console.log('removeItems',removeItems);
    // Loop through each variant ID
    removeItems.forEach((variant) => {
      const removeButton = document.querySelector(`cart-remove-button button[data-variant-id="${variant.id}"]`);
  
      if (!removeButton) {
        console.warn(`No remove button found for variant ID: ${variant.id}`);
        return;
      }
  
      const cartRemoveButton = removeButton.closest('cart-remove-button');
      const cartItems = removeButton.closest('cart-items') || removeButton.closest('cart-drawer-items');
  
      if (!cartItems) {
        console.warn(`No cart container found for variant ID: ${variant.id}`);
        return;
      }
  
      const index = cartRemoveButton?.dataset?.index;
  
      if (!index) {
        console.warn(`No index found for variant ID: ${variant.id}`);
        return;
      }
  
      // Call the updateQuantity function with quantity = 0 (removal)
      cartItems.updateQuantity(parseInt(index), 0);
    });
    
  } else {
    console.warn('No matching free items to remove');
  }
  
  // Handle countdown timers
  cartJSON.items
    .filter(item => item?.properties?._free_pro_mm)
    .forEach(item => {
      if (item?.properties?._free_pro_timer) {
        freProCountdown(item.id, item.properties._free_pro_mm, item.properties._free_pro_ss);
      }
    });
}

// Paged Loaded Free Product Timer Start
document.addEventListener('DOMContentLoaded', function(event) {
  getCartJSON().then(cartJSON => {
    cartJSON.items
    .filter(item => item?.properties?._free_pro_mm)
    .forEach(item => {
      if (item?.properties?._free_pro_timer) {
        freProCountdown(item.id, item.properties._free_pro_mm, item.properties._free_pro_ss);
      }
    });
  });
});


// Cart item coundown timer Start
// Initialize the countdown object if it doesn't already exist
window.countdown = window.countdown || {};

// Function to start a countdown timer for a given id, with specified minutes and seconds
function freProCountdown(id, minutes, seconds) {
  // Check if there's already a timer running for this id
  if (window.countdown[id] !== null && window.countdown[id] !== undefined) {
    // console.log(`Countdown for ${id} is already running.`);
    return;
  }

  // Set the end time based on the provided minutes and seconds
  const totalMilliseconds = (minutes * 60 + seconds) * 1000;
  const endTime = new Date().getTime() + totalMilliseconds;

  // Function to update the countdown every second
  window.countdown[id] = setInterval(() => {
    const now = new Date().getTime();
    const timeRemaining = endTime - now;

    // Calculate minutes and seconds remaining
    const minutesLeft = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const secondsLeft = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Display the countdown
    // console.log(`Time left for ${id}: ${minutesLeft}m ${secondsLeft}s`);
    let target = document.getElementById(`countdown-${id}`);
    if(target != null && target != undefined){
      target.innerHTML = `${minutesLeft}m ${secondsLeft}s`;
    }

    getCartJSON().then(cart => {
      const itemExists = cart.items.find((item) => item.id === id);
      // console.log('itemExists', itemExists);
      if (!itemExists || cart.items.length === 0 || itemExists == undefined) {
        clearCountdown(id)
        // console.log(`Item with ID ${id} is not in the cart.`);
      } else {
        // console.log(`Item with ID ${id} is already in the cart.`);
      }
    });

    // Check if the countdown has ended
    if (timeRemaining < 0) {
      clearInterval(window.countdown[id]);
      window.countdown[id] = null; // Reset the timer for the given id
      // console.log(`Countdown for ${id} finished!`);
      if(target != null && target != undefined){
        target.innerHTML = "Expired.";
      }
    }
  }, 1000);
}

// Function to clear the countdown for a given id
function clearCountdown(id) {
  if (window.countdown[id] !== null && window.countdown[id] !== undefined) {
    clearInterval(window.countdown[id]);
    window.countdown[id] = null;
    // console.log(`Countdown for ${id} has been cleared.`);
  } else {
    // console.log(`No active countdown for ${id} to clear.`);
  }
}
// Cart item coundown timer End


const getCartJSON = async () => {
  try {
    const response = await fetch('/cart.js'); // Fetch cart data from Shopify's AJAX API
    const cartData = await response.json(); // Parse the JSON response
    return cartData; // Return the cart data for further use
  } catch (error) {
    console.error('Error fetching cart data:', error); // Handle any errors
  }
};
function openfreeProPopup(data) {
  getCartJSON().then(cart => {
    if(window.free_product != null){
      let freeProductHandle = window.free_product.handle;

      const matchingItem = cart.items.find(item => item.handle === freeProductHandle);
      console.log();
      if (matchingItem) {
        // console.log('Matching handle found in cart:', matchingItem);
      } else {
        // console.log('Free product handle not found in the cart.');
        document.querySelector('.free_product_popup_container').classList.add('open');
      }
    }
  });
}


// For set the bundle id
window.product_free_pro_id = getRandomId();

var allvariantSelect = false;
function freeProSelectOption(product_handle = null, current_option = null){

  // soldout Option
  freeProSoldoutOption(product_handle, current_option);
  
  // let product_variants= product.variants;
  freeProselectSize();
  let allProducts = document.querySelectorAll('[free-product]');
  window.product_free_pro_id = getRandomId();
  allProducts.forEach((pro_element, index, array)=> {
    let product= JSON.parse($(pro_element).find('.product-json').html());
    let product_variants = product.variants;
    // console.log(product);
    let option_array = [];
    if($(pro_element).find('.ProductForm__Option').length != 0){
      let variant_count = $(pro_element).find('.ProductForm__Option').length;
      let options = $(pro_element).find('.ProductForm__Option');
      
      for (var i = 0; i < options.length; i++) {
        let option = $(options[i]).find('[type="radio"]:checked').val();
        if(option != undefined && option != null){
          option_array.push(option);
        }
      }
      if(variant_count == option_array.length){
        let variant_title = '';
        for (var i = 0; i < option_array.length; i++) {
          let option = $(options[i]).find('[type="radio"]:checked').val();
          if(variant_title != ''){
            variant_title = variant_title + ' / ' + option_array[i];
          } else {
            variant_title = option_array[i]
          }
        }
        // let select_variant = product_variants.filter(x => (option_array.includes(x.option1) && option_array.includes(x.option2)));
        let select_variant = product_variants.filter(x => (variant_title === x.title ));
        if(select_variant.length > 0){
          if(select_variant != null && select_variant != undefined && select_variant[0].available){
            $(pro_element).find('.selectedVariantId').val(select_variant[0].id);
          } else {
            $(pro_element).find('.selectedVariantId').val('');
          }
        }
        freeProButtonEnable();
      }
      
    }
  });
}

function freeProButtonEnable(){
  let allProducts = document.querySelectorAll('[name="variant id"]');
  let variant_array = [];
  for (var i = 0; i < allProducts.length; i++) {
    if($(allProducts[i]).val() != ''){
      variant_array.push(Number($(allProducts[i]).val()));
    }
  }
  // console.log(variant_array);
  if(allvariantSelect && allProducts.length == variant_array.length){
    $("#free_pro_addtocart").show();
    $("#free_pro_soldout").hide();
    $("#free_pro_soldout").removeClass('sold-out');
    $("#free_pro_soldout").prop('disabled', false);
    $("#free_pro_soldout span").html('ADD TO CART');

    // $(".bundle-product .ProductForm__Variants .HorizontalList__Item label").removeClass('sold-out');
  } else if(allvariantSelect && allProducts.length != variant_array.length) {
    $("#free_pro_addtocart").hide();
    $("#free_pro_soldout").show();
    $("#free_pro_soldout").addClass('sold-out');
    $("#free_pro_soldout").prop('disabled', true);
    $("#free_pro_soldout span").html('Sold Out');

    // $(".bundle-product .ProductForm__Variants .HorizontalList__Item label").addClass('sold-out');
  } else {
    $("#free_pro_addtocart").hide();
    $("#free_pro_soldout").show();
    $("#free_pro_soldout").removeClass('sold-out');
    $("#free_pro_soldout").prop('disabled', false);
    $("#free_pro_soldout span").html('ADD TO CART');

    // $(".bundle-product .ProductForm__Variants .HorizontalList__Item label").addClass('sold-out');
  }
}

function freeProselectSize(){
  let allProducts = document.querySelectorAll('.SizeSwatchList');
  let active_size_check = 0;
  for (var i = 0; i < allProducts.length; i++) {
    let checkSizeSelect = false;
    $(allProducts[i]).find('[type="radio"]').each(function () {
      if($(this).is(":checked")){
        checkSizeSelect = true;
      }
    });
    let key = $(allProducts[i]).attr('key');
    $('#select-size-message-free-pro-'+key).show();
    if(checkSizeSelect){
      active_size_check = active_size_check + 1;
      $('#select-size-message-free-pro-'+key).hide();
    }
  }
  if(active_size_check == allProducts.length){
    allvariantSelect = true;
  }
  // console.log(allvariantSelect);
}

async function freeProAddtocart() {
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const allProducts = document.querySelectorAll('.ProductForm__Variants.free-pro');
  const items = [];

  allProducts.forEach((form) => {
    const variantInput = $(form).find('[name="variant id"]');
    const variant = parseInt(variantInput.val());
    if (!variant) return;

    const free_pro_handles = $(form).find('.free_pro_handles').val();
    const mm = parseInt(variantInput.data('mm'));
    const ss = parseInt(variantInput.data('ss'));
    const timer = variantInput.data('timer');

    items.push({
      id: variant,
      quantity: 1,
      properties: {
        _free_pro_id: window.product_free_pro_id,
        _free_pro_handles: free_pro_handles,
        _free_pro_mm: mm,
        _free_pro_ss: ss,
        _free_pro_timer: timer,
      },
    });
  });

  if (items.length === 0) return;

  const formData = {
    items,
    sections: cartDrawer?.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };

  const { success, data } = await addItemsToCart(formData);

  if (!success) return;

  // Optionally update cart drawer contents
  if (cartDrawer && data.sections) {
    cartDrawer.renderContents(data);
  }

  closefreeProPopup();
}

async function addItemsToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    });

    const responseData = await response.json();

    if (!response.ok) {
      console.error('❌ Error adding to cart:', responseData);
      return { success: false, data: responseData };
    }

    // Dispatch product added event
    document.dispatchEvent(new CustomEvent('product:added', { detail: responseData, bubbles: true }));
    
    return { success: true, data: responseData };
  } catch (error) {
    console.error('❌ Network error:', error);
    return { success: false, data: null };
  }
}


function freeProSoldoutOption(product_handle = null, current_option = null){
  let curt_color = $('#swatch-'+current_option+'.ColorSwatchList .ColorSwatch__Radio:checked').val();
  let all_size = $('#swatch-'+current_option+'.SizeSwatchList .SizeSwatch__Radio');
  let all_size_option = [];
  all_size.each(function() {all_size_option.push(this.value)});
  let product = JSON.parse($('#json-'+current_option).html())
  // jQuery.getJSON(window.Shopify.routes.root + 'products/'+ product_handle +'.js', function(product) {
    let all_variants = product.variants;
    // console.log(product.variants);
    const all_match_option = all_size_option.map(size => curt_color.concat(' / ', size));
    // console.log(all_match_option);

    all_size_option.forEach((size, i) => {
      all_variants.forEach((variant, j) => {
        if(variant.title == all_match_option[i]){
          if(variant.available == true){
            $('#swatch-'+current_option+'.SizeSwatchList .SizeSwatch__Radio[value="'+size+'"]').removeClass('soldout');
          } else if(variant.available == false){
            $('#swatch-'+current_option+'.SizeSwatchList .SizeSwatch__Radio[value="'+size+'"]').addClass('soldout');
          } 
        }
      });
    });
    
  // });
}

function getRandomId() {
    var S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4()+"-"+S4()+S4()+S4()+"-"+S4()+S4()+S4());
}
// Free Product Popup

// See in your size Chart Start
$(document).ready(function(){
 setTimeout(function () {
    $('.see-in-your-size-popup .inner-block .right-block .size a:first-child').trigger('click');
  }, 200);

  $(".see-in-your-size-popup .inner-block .right-block .size a" ).click(function(e) {
    e.preventDefault();

    var Size = $(this).text();

    $(".see-in-your-size-popup .inner-block .right-block button").empty();
    $(".see-in-your-size-popup .inner-block .right-block button").append("Select Size " + Size);

    // $(".tab-nav h3").not($(this)).removeClass("active");
    
    $('.see-in-your-size-popup .inner-block .right-block .size a').removeClass('active');
    $(this).addClass('active');
    var CurrentTab = $( this ).attr('id');
    var selectTab = '[select-id="'+ CurrentTab +'"]';

    $(".see-in-your-size-popup .inner-block .left-block img").hide();
    $(".see-in-your-size-popup .inner-block .right-block .content p").hide();
    $(selectTab).fadeIn('fast');
     // $('.article-block .article').slick('refresh');
  });

  $('.see-in-your-size-popup .right-block .selected-size').click(function(){
    var GetSize = $(".see-in-your-size-popup .inner-block .right-block .size a.active" ).text().replace('/', '-');
    $('fieldset .variant-button-wrapper .varaint-button-option input[value="'+GetSize+'"]').trigger('click');
    $('.see-in-your-size-popup .see-in-your-size-popup-close').trigger('click');
  });
});
// See in your size Chart End


// Static Page Faq Js 
$(document).ready(function() {
  $(".accordion-wrapper").find(".accordion-toggle").click(function() {
    $(this).next().slideToggle("slow"),
      $(this).toggleClass("active"),
      $(".accordion-content").not($(this).next()).slideUp("slow"),
      $(".accordion-toggle").not($(this)).removeClass("active")
  })
})
// Static Page Faq Js end


$(document).ready(function(){
  $('.MegaMenu .last_linkList.image a').hover(function (event) {
    event.preventDefault();
    $(this).addClass('active');
    $('.megamenu-image .MegaMenu__Push').hide();
    console.log("")
    $("."+$(this).attr('image')).show();
     $(".MegaMenu .last_linkList.image a").not($(this)).removeClass("active");
  });
  
  $( ".MegaMenu .last_linkList.image a" ).mouseleave (function() {  
    $('.MegaMenu .last_linkList.image a.active').removeClass( "active" ); 
    $('.megamenu-image .MegaMenu__Push').hide();
    
    $('.megamenu-image .MegaMenu__Push:first-child').show();
  });
});

$(document).ready(function(){   
  var main = document.querySelector('header-drawer');
  $('header-drawer .menu-block > a:first-child').click(function(){
    event.preventDefault();
    $("header-drawer .level1").css("display", "none");
    $("header-drawer .second-level .second-level-main").css("display", "block");
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "none");
    main.scrollTop = 0;
  });

  $('header-drawer .second-level .second-level-main .second-level-title').click(function(){
    $("header-drawer .second-level .second-level-main").css("display", "none");
    $("header-drawer .level1").css("display", "block");
    main.scrollTop = 0;
  });
  
  $('header-drawer .menu-block > a:last-child').click(function(){
    event.preventDefault();
    $("header-drawer .level1").css("display", "none");
    $("header-drawer .second-level .second-level-main").css("display", "none");
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "block");
    main.scrollTop = 0;
  });

  $('header-drawer .second-level .second-level-main.second-level-main-new .second-level-title').click(function(){
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "none");
    $("header-drawer .level1").css("display", "block");
    main.scrollTop = 0;
  });
});



// Cart Upsell Addtocart Start
document.addEventListener('DOMContentLoaded', () => {
  // Set up variant change listener
  document.querySelectorAll('.product-upsell-inner').forEach(container => {
    const select = container.querySelector('.upsell-variant-select');
    const button = container.querySelector('.upsell-add-btn');

    if (!select || !button) return;

    function updateButtonState() {
      const selectedOption = select.options[select.selectedIndex];
      const isAvailable = selectedOption.dataset.available === 'true';

      if (isAvailable) {
        button.textContent = 'Add';
        button.disabled = false;
        button.classList.remove('sold-out');
      } else {
        button.textContent = 'Sold';
        button.disabled = true;
        button.classList.add('sold-out');
      }
    }

    select.addEventListener('change', updateButtonState);
    updateButtonState(); // Initial run
  });

  // Add-to-cart logic with availability check
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-add-btn');
    if (!btn || btn.disabled) return;

    try {
      const container = btn.closest('.product-upsell-inner');
      const select = container.querySelector('.upsell-variant-select');
      const selectedOption = select.options[select.selectedIndex];

      const variantId = Number(selectedOption.value);
      const isAvailable = selectedOption.dataset.available === 'true';

      if (!isAvailable) {
        console.warn('Variant is unavailable.');
        return;
      }

      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const items = [{
        id: Number(variantId),
        quantity: 1,
      }];

      const formData = {
        items,
        sections: cartDrawer?.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname,
      };

      const { success, data } = await addItemsToCart(formData);
      
      if (!success) return;
      console.log(success);
      console.log(data);
    
      // Optionally update cart drawer contents
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
      }

      console.log('Upsell product added!');
    } catch (err) {
      console.error('Error adding upsell product:', err);
    }
  });
});
// Cart Upsell Addtocart End


// Cart Timer Start
document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    // console.log('Welcome back to the tab!');
    let cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer) {
      let attributeValue = cartDrawer.getAttribute('aria-hidden');
      // console.log('Attribute value:', attributeValue);
      if (attributeValue == 'false') {
        startCountdownCart();
      }
    }
  }
});
document.addEventListener("cart:drawer:open",startCountdownCart,false);
document.addEventListener("cart:updated",startCountdownCart,false);

// let countdownDuration = 60; // Set initial countdown duration in seconds (e.g., 60 seconds = 1 minute)
let timerInterval = null; // Initialize the interval variable

function startCountdownCart() {
  let timerEle = document.getElementById('timer'); // or use document.getElementById('your-element-id');
  if(timerEle) {
    // console.log('element is available');
    // Check if there's already an existing timer running
    if (timerInterval) {
      clearInterval(timerInterval); // Clear the existing interval
      timerInterval = null;
    }

    // Reset the countdown duration if needed
    let startMinutes = 59;  // Example: 59 minutes
    let startSeconds = 52; // Example: 52 seconds
    let countdownDuration = startMinutes * 60 + startSeconds;

    // Start a new interval
    timerInterval = setInterval(() => {
      
        // Calculate minutes and seconds
        let minutes = Math.floor(countdownDuration / 60);
        let seconds = countdownDuration % 60;

        // Add leading zeros if necessary
        minutes = minutes < 10 ? ((minutes==0)?0:`0${minutes}`) : minutes;
        seconds = seconds < 10 ? ((seconds==0)?0:`0${seconds}`) : seconds;

        // Display the countdown timer
        document.getElementById('timer').innerText = `${minutes}m ${seconds}s`;

        // Decrement the countdown
        countdownDuration--;

        // If the countdown reaches 0, stop the timer
        if (countdownDuration < 0) {
            clearInterval(timerInterval);
            document.getElementById('timer').innerText = "0m 0s";
            timerInterval = null; // Reset the interval variable
        }
    }, 1000); // Update every second
  }
}
// Cart Timer End

